<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <div class="row">
            <div class="col-md-10 col-12">
              <b>Daftar Surat Masuk</b>
            </div>

            <!-- <div class="col-md-2 col-12" v-if="canSeeAll">
              <select
                class="pull-right form-control"
                v-model="from"
                @change="loadItems"
              >
                <option value="me">Diri Sendiri</option>
                <option value="all">Satu Unit</option>
                <option value="pimpinan">Atensi Pimpinan</option>
              </select>
            </div> -->
          </div>
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb arr-right bg-white">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">
              Surat Masuk
            </li>
          </ol>
        </nav>
        <hr />
        <div class="row">
          <p class="text-right h6 pl-3">Filtering Data</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomInput
                label="Nomor Surat / Perihal"
                :model="customFilter.document_number"
                @data="setSearchValue('document_number', $event)"
                @clear="setSearchValue('document_number', $event)"
                label-block
                toggle-clear
              />
            </div>
            <div class="form-group">
              <CustomMulti
                label="Sifat Surat"
                :query="documentUrgency"
                :list="documentUrgencyList"
                :model="customFilter.document_urgency"
                @data="setSearchValue('document_urgency', $event)"
                @clear="setSearchValue('document_urgency', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>

            <div class="form-group" style="display: none">
              <CustomMulti
                label="Status"
                :list="documentApprovalList"
                :model="customFilter.final_approved"
                @data="setSearchValue('final_approved', $event)"
                @clear="setSearchValue('final_approved', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>

            <div class="form-group">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="loadItems()"
              >
                Cari
              </button>
            </div>
          </div>

          <div class="col-md-6 col-sm-6">
            <form method="post" @submit.prevent="filterData">
              <div class="col-md-12">
                <label for="tanggal">Tanggal</label>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <input
                        type="date"
                        class="form-control"
                        data-date=""
                        data-date-format="YYYY-MM-DD"
                        v-model="customFilter.start_date"
                        @data="setSearchValue('start_date', $event)"
                        @clear="setSearchValue('start_date', $event)"
                      />
                    </div>
                    <!-- {{customFilter.start_date}} -->
                  </div>
                  <div
                    class="col-1 text-center"
                    style="padding-right: 0px; padding-left: 0px"
                  >
                    -
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <input
                        type="date"
                        class="form-control"
                        data-date=""
                        data-date-format="YYYY-MM-DD"
                        v-model="customFilter.end_date"
                        @data="setSearchValue('end_date', $event)"
                        @clear="setSearchValue('end_date', $event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <CustomMulti
                  label="Kecepatan Surat"
                  :query="documentSpeed"
                  :list="documentSpeedList"
                  :model="customFilter.document_speed"
                  @data="setSearchValue('document_speed', $event)"
                  @clear="setSearchValue('document_speed', $event)"
                  toggle-clear
                  label-block
                  close-on-select
                />
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row m-b-10">
              <div class="col-lg-12">
                <button
                  class="btn btn-success float-right"
                  @click="goToAddView()"
                >
                  Create
                </button>
              </div>
            </div>
            <!-- <Datatables table-name="document_in" :trigger="{
              from: function(){
                return from
              }
            }" @doDetail="doDetail" @doEdit="doEdit" @doKonfirmasi="doKonfirmasi" @doDisposisi="doDisposisi" @doAtasan="doAtasan" :action="true" action-data="row_number" :url="'document_in'" :columnFiltering="true" :dtfields="headers">
              <template slot-scope="props">
              <div class="btn-group btn-sm" role="group" aria-label="Basic example">
                <button type="button" v-if="!forbidRead" data-action="doDetail" class="btn btn-success btn-sm"><i class="mdi mdi-magnify"></i></button>
                <button type="button" v-if="!forbidUpdate && props.ctx.data.canEdit == true" data-action="doEdit" class="btn btn-warning btn-sm"><i class="mdi mdi-grease-pencil"></i></button>
                <button type="button" v-if="!forbidUpdate && props.ctx.data.canKonfirmasi == true" data-action="doKonfirmasi" class="btn btn-info btn-sm"><i class="mdi mdi-check"></i></button>
                <button type="button" v-if="!forbidUpdate && props.ctx.data.canDisposisi == true" data-action="doDisposisi" class="btn btn-secondary btn-sm"><i class="mdi mdi-account"></i></button>
                <button type="button" v-if="!forbidAtasan && props.ctx.data.flag_atasan < '1'" data-action="doAtasan" class="btn btn-warning btn-sm"><i class="mdi mdi-account-star"></i></button>
                <button type="button" v-if="props.ctx.data.isBold" class="btn btn-cyan btn-sm"><i class="fa fa-folder"></i></button>
                <button type="button" v-else class="btn btn-cyan btn-sm"><i class="fa fa-folder-open"></i></button>
              </div>
              </template>
            </Datatables> -->
            <vue-good-table
              mode="remote"
              :pagination-options="{
                enabled: true,
                setCurrentPage: curPage,
                jumpFirstOrLast : true,
              }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="total"
              :columns="columns"
              :rows="rows"
              :isLoading.sync="isLoading"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'">
                  <button
                    type="button"
                    v-if="!forbidRead"
                    @click="doDetail({ id: props.row.id })"
                    class="btn btn-success btn-sm mr-2"
                  >
                    <i class="mdi mdi-magnify"></i>
                  </button>
                  <button
                    type="button"
                    v-if="props.row.canEdit"
                    @click="doEdit({ id: props.row.id })"
                    class="btn btn-warning btn-sm mr-2"
                  >
                    <i class="mdi mdi-grease-pencil"></i>
                  </button>
                  <button
                    type="button"
                    v-if="props.row.canEdit"
                    @click="doDelete({ id: props.row.id })"
                    class="btn btn-danger btn-sm mr-2"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    type="button"
                    v-if="props.row.canKonfirmasi == true"
                    @click="doKonfirmasi({ id: props.row.id })"
                    class="btn btn-info btn-sm mr-2"
                  >
                    <i class="mdi mdi-check"></i>
                  </button>
                  <button
                    type="button"
                    v-if="
                      props.row.disposisi == true &&
                      props.row.canKonfirmasi == false
                    "
                    @click="doDisposisi({ id: props.row.id })"
                    class="btn btn-secondary btn-sm mr-2"
                  >
                    <i class="mdi mdi-account"></i>
                  </button>
                  <!-- <button
                    type="button"
                    v-if="!forbidAtasan && props.row.flag_atasan < '1'"
                    @click="doAtasan({ id: props.row.id })"
                    class="btn btn-warning btn-sm mr-2"
                  >
                    <i class="mdi mdi-account-star"></i>
                  </button> -->
                  <button
                    v-if="
                      props.row.disposisi == true &&
                      props.row.canKonfirmasi == false
                    "
                    type="button"
                    @click="showModalCalendar(props.row)"
                    class="btn btn-sm btn-info"
                    title="Add to Calendar"
                  >
                    <i class="mdi mdi-calendar"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>

      <hr />
      <div class="card card-body printableArea">
        <div class="col-md-12">
          <h4>Petunjuk :</h4>
        </div>
        <div class="col-md-12">
          <table>
            <tr>
              <td>
                <span class="btn-sm btn-secondary mr-1">
                  <i class="mdi mdi-magnify"></i>
                </span>
              </td>
              <td style="font-size: 13px">Untuk melihat data detail</td>
            </tr>
            <tr>
              <td colspan="2">&nbsp;</td>
            </tr>
            <tr>
              <td>
                <button class="btn-sm btn-secondary mr-1">
                  <i class="mdi mdi-archive"></i>
                </button>
              </td>
              <td style="font-size: 13px">Untuk memberi tanggapan</td>
            </tr>

            <tr>
              <td colspan="2">&nbsp;</td>
            </tr>

            <tr>
              <td>
                <button class="btn-sm btn-secondary mr-1">
                  <i class="mdi mdi-human"></i>
                </button>
              </td>
              <td style="font-size: 13px">Untuk mendisposisikan</td>
            </tr>

            <tr>
              <td colspan="2">&nbsp;</td>
            </tr>

            <tr>
              <td>
                <button class="btn-sm btn-secondary mr-1">
                  <i class="mdi mdi-file"></i>
                </button>
              </td>
              <td style="font-size: 13px">Download</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- {{ this.router.push }} -->
    </div>
    <ModalCalendar
      v-show="isModalCalendar"
      @close="closeModal"
      :dataCalendar="dataCalendar"
    />
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
import ModalCalendar from "./modal/addCalendar";

export default {
  components: {
    ModalCalendar,
  },
  data() {
    // let _this = this
    let roles = this.$store.state.profile.user.datarole1;

    return {
      curPage: 1,
      start_date: "",
      end_date: "",
      from: roles,
      documentSpeedList: [],
      documentUrgencyList: [],
      documentApprovalList: [
        { value: 1, text: "approved" },
        { value: 2, text: "pending" },
        { value: 3, text: "decline" },
        { value: 4, text: "revision" },
        { value: 5, text: "retract" },
      ],
      customFilter: {
        document_number: null,
        final_approved: null,
        document_urgency: null,
        document_speed: null,
        start_date: null,
        end_date: null,
      },
      columns: [
        { label: "Action", field: "id", width: "250px", sortable: false },
        // { label: 'Nomor Agenda', field: 'agenda_number', sortable: false },
        { label: "Perihal", field: "subject", width: "150px", sortable: false },
        { label: "Nomor Surat", field: "nomorsurat", width: "150px" },
        {
          label: "Asal Surat",
          field: "asal_surat",
          width: "150px",
          sortable: false,
        },
        {
          label: "Sifat Surat",
          field: "sifat",
          width: "150px",
          sortable: false,
        },
        {
          label: "Tanggal Diterima",
          field: "tanggal_diterima",
          width: "150px",
        },
        { label: "Tanggal SLA", field: "tanggal_sla", width: "150px" },
        { label: "Redaksi", field: "redaksi", width: "150px", sortable: false },
        { label: "Profil", field: "profil", width: "150px", sortable: false },
        {
          label: "Status",
          field: "status",
          width: "150px",
          sortable: false,
        },
      ],
      rows: [],
      isLoading: false,
      total: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: 10,
      },
      isModalCalendar: false,
      dataCalendar: {},
      // headers:{
      //   subject:{
      //     label:'Perihal',
      //     data:'subject',
      //   },
      //   agenda_number:{
      //     label:'Nomor Agenda',
      //     data:'agenda_number',
      //   },
      //   nomor_surat:{
      //     label:'Nomor Surat',
      //     data:'nomor_surat',
      //   },
      //   asal_surat:{
      //     label:'Asal Surat',
      //     data:'asal_surat',
      //   },
      //   sifat:{
      //     label:'Sifat Surat',
      //     data:'sifat',
      //   },
      //   tanggal_diterima:{
      //     label:'Tanggal Diterima',
      //     data:'tanggal_diterima',
      //     render:function(data){
      //       return this.formatDate(data)
      //     }
      //   },
      //   tanggal_sla:{
      //     label:'Tanggal SLA',
      //     data:'tanggal_sla',
      //     render:function(data){
      //       return this.formatDate(data)
      //     }
      //   },
      //   redaksi:{
      //     label:'Redaksi',
      //     data:'redaksi',
      //   },
      //   profil:{
      //     label:'Profil',
      //     data:'profil',
      //   },
      //   status:{
      //     label:'Status',
      //     data:'status',
      //   },
      // }
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    forbidUpdate() {
      if (this.$store.state.profile.permissions.document_in) {
        return !this.$store.state.profile.permissions.document_in.update;
      }
      return false;
    },
    canSeeAll() {
      if (this.$store.state.profile.permissions.document_in_all) {
        return this.$store.state.profile.permissions.document_in_all.read;
      }
      return false;
    },
    forbidRead() {
      if (this.$store.state.profile.permissions.document_in) {
        return !this.$store.state.profile.permissions.document_in.read;
      }
      return false;
    },
    forbidAtasan() {
      if (this.$store.state.profile.permissions.document_in) {
        return !this.$store.state.profile.permissions.document_in.read;
      }
      return false;
    },
    forbidKonfirmasi() {
      if (this.$store.state.profile.permissions.document_in_confirm) {
        return this.$store.state.profile.permissions.document_in_confirm.create;
      }
      return false;
    },
    forbidDel() {
      if (this.$store.state.profile.permissions.document_in) {
        return !this.$store.state.profile.permissions.document_in.delete;
      }
      return false;
    },
    forbidDisposisi() {
      if (this.$store.state.profile.permissions.disposition_in) {
        return this.$store.state.profile.permissions.disposition_in.create;
      }
      return false;
    },
  },
  async created() {
    let curPage = localStorage.getItem('documentIn.curPage');
    curPage = curPage ? curPage : 1;
    this.curPage = curPage * 1;
  },
  async mounted() {
    const state = {
      loaded: true,
      isAdd: false,
      isEdit: false,
      isDetail: false,
    };
    this.$store.commit("documentIn/STATE", state);
    await this.loadItems();
  },
  methods: {
    setValue(model, data) {
      this.form[model] = data;
    },
    setSearchValue(model, data) {
      this.customFilter[model] = data;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
      localStorage.setItem('documentIn.curPage', params.currentPage);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    async loadItems() {
      this.isLoading = true;

      let { perPage, page, sort } = this.serverParams;

      let {
        document_number,
        final_approved,
        document_urgency,
        document_speed,
        start_date,
        end_date,
      } = this.customFilter;

      let start = (page - 1) * perPage;
      let url =
        "document_in?perPage=" + perPage + "&page=" + start + "&jenis=surat";

      if (document_number) {
        url += "&number=" + document_number;
      }
      if (final_approved) {
        url += "&approved=" + final_approved.value;
      }
      if (document_urgency) {
        url += "&urgency=" + document_urgency.value;
      }
      if (document_speed) {
        url += "&speed=" + document_speed.value;
      }
      if (start_date && end_date) {
        if (!this.laterThan(start_date, end_date)) {
          const message = {
            title: this.$t("error"),
            text: "Perhatikan Filter Tanggal, tanggal awal tidak boleh lebih dari tanggal akhir",
            type: "error",
          };
          this.$store.commit("addNotification", message);
        } else {
          url += "&start_date=" + start_date + "&end_date=" + end_date;
        }
      }
      if (this.from) {
        url += "&from=" + this.from;
      }
      if (sort.length) {
        sort.forEach((item, index) => {
          url +=
            `&sort[${index}][field]=${item.field}` +
            `&sort[${index}][type]=${item.type}`;
        });
      }

      let resp = await axios.get(url);

      this.rows = resp.data.data;
      this.total = resp.data.recordsTotal;

      this.isLoading = false;
    },
    documentUrgency(query) {
      axios.get(`document_urgencies/list?s=${query}`).then((res) => {
        this.documentUrgencyList = res.data.items;
      });
    },
    documentSpeed(query) {
      axios.get(`document_speeds/list?s=${query}`).then((res) => {
        this.documentSpeedList = res.data.items;
      });
    },
    documentName(query) {
      axios.get(`clasification/list-active?s=${query}`).then((res) => {
        this.documentNameList = res.data.items;
      });
    },
    goToAddView() {
      this.$store.dispatch("documentIn/onAdd");
    },
    changeDt() {
      this.$children[0].$refs.table.reload();
    },
    doDetail(val) {
      this.$store.dispatch("documentIn/onDetail", val);
    },
    showModalCalendar(val) {
      axios.get(`document_in/calender/${val.id}`).then((res) => {
        this.dataCalendar = res.data.data;
      });
      this.isModalCalendar = true;
    },
    closeModal() {
      this.isModalCalendar = false;
    },
    // doDetail(val) {
    //   // this.$store.dispatch("documentIn/onDetail", val);
    //   // const link = document.createElement('a')
    //   const idsurat = val.id
    //   // link.href = `${this.baseUrl}/${val}/export-excel?start_date=${this.start_date}&end_date=${this.end_date}&unit_id=${unit_id}`
    //   // link.href = `http://localhost:8080/documentIn/detail/${val.id}`
    //   // router.push({ name: 'user', params: { idsurat } })
    //   // link.href = router.push({ name: 'user', params: { idsurat } })
    //   // link.href = `https://dev-eopis.kemlu.go.id/api/documentIn/detail/${val.id}`
    //   // link.target = "_blank";
    //   // link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

    //   let route = this.$router.resolve({path: '/documentIn/detail'});
    //   let route1 = `${route.href}/${val.id}`;
    //   // let route = this.$router.resolve({
    //   //   name: 'ProductDetail',
    //   //   params: { id: val.id },
    //   // });
    //   // let route = this.$router.push({name: 'documentIn/detail', params: { id: 1 }});
    //   // let route = this.$router.resolve('/link/to/page'); // This also works.
    //   window.open(route1, '_blank');
    // },
    // doBerkas(val) {
    //   const data = {
    //     id: val.id,
    //     flag_atasan: 1,
    //   };
    //   // const data = JSON.stringify(payload);
    //   this.$store.dispatch("documentIn/submitTandaiAtasan", data);
    // },
    doAtasan(val) {
      const data = {
        id: val.id,
        flag_atasan: 1,
      };
      // const data = JSON.stringify(payload);
      this.$store.dispatch("documentIn/submitTandaiAtasanDepan", data);
    },
    doEdit(val) {
      this.$store.dispatch("documentIn/onEdit", val);
    },
    doKonfirmasi(val) {
      this.$store.dispatch("documentIn/onKonfirmasi", val);
    },
    // doKonfirmasi(val) {
    //   this.$store.dispatch("documentIn/onConfirm", val);
    // },
    doDisposisi(val) {
      this.$store.dispatch("documentIn/onDisposisi", val);
    },
    doDelete(val) {
      this.$store.dispatch("documentIn/submitDelete", val);
    },
  },
};
</script>
